import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const homeOnboardingRedirectRoute: InvariantJiraRoute = {
	name: 'home-onboarding-redirect',
	path: '/jira/your-work-onboarding',
	exact: true,
};
